import { ApiClient } from '../client/ApiClient';
import { ApiResponse } from '../types';
import { KlaviyoResponse, NotifyMePayload } from './types';

export class KlaviyoOnSiteClient extends ApiClient {
  private readonly _klaviyoSubscribeUrl: string;
  private readonly _klaviyoEnvironment: string;
  private readonly _klaviyoNotifyMeListId: string;

  constructor({
    klaviyoEnvironment,
    klaviyoSubscribeUrl,
    klaviyoNotifyMeListId,
  }: {
    klaviyoSubscribeUrl: string;
    klaviyoEnvironment: string;
    klaviyoNotifyMeListId: string;
  }) {
    super();
    this._klaviyoEnvironment = klaviyoEnvironment;
    this._klaviyoSubscribeUrl = klaviyoSubscribeUrl;
    this._klaviyoNotifyMeListId = klaviyoNotifyMeListId;
  }

  protected get requestHeaders(): Record<string, string> {
    return {
      'Content-Type': 'application/x-www-form-urlencoded',
    };
  }

  protected get mode(): 'cors' | 'navigate' | 'no-cors' | 'same-origin' | undefined {
    return 'cors';
  }

  notifyMe = async (
    email: string,
    productId: string,
    variantId: number,
    shouldSubscribeForNewsletter: boolean
  ): Promise<ApiResponse<KlaviyoResponse>> => {
    const body: NotifyMePayload = {
      a: this._klaviyoEnvironment,
      g: this._klaviyoNotifyMeListId,
      email: email,
      product: productId,
      variant: variantId,
      subscribe_for_newsletter: shouldSubscribeForNewsletter,
      platform: 'shopify',
    };

    const formBody = Object.keys(body)
      .map(key => encodeURIComponent(key) + '=' + encodeURIComponent(body[key]))
      .join('&');

    const { data, statusCode, error } = await this._fetch<KlaviyoResponse>({
      path: `${this._klaviyoSubscribeUrl}?company_id=${this._klaviyoEnvironment}`,
      method: 'POST',
      body: formBody,
    });

    if (error) {
      console.log('error from KlaviyoClient', { error, statusCode });
      return { error, statusCode };
    }
    return { data, statusCode };
  };
}
